import { useTranslation } from "@refinedev/core";

import CloseRounded from "@mui/icons-material/CloseRounded";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirmColor?: "primary" | "secondary" | "error";
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  confirmColor = "primary",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const { translate } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" id="confirm-dialog-title">
            {title}
          </Typography>
          <Typography component="span" color="text.primary">
            <IconButton onClick={onCancel} data-testid="confirm-dialog-close" aria-label={translate("buttons.cancel")}>
              <CloseRounded />
            </IconButton>
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description" color="text.primary" whiteSpace="pre-wrap">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="dialog" color="inherit" data-testid="confirm-dialog-cancel" onClick={onCancel}>
          {translate("buttons.cancel")}
        </Button>
        <Button
          variant="dialog"
          color={confirmColor}
          data-testid="confirm-dialog-confirm"
          onClick={onConfirm}
          autoFocus
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
